// The open data API (SSB population and workplaces): its own base URL, separate from demo routing.
// This is the one module that reads REACT_APP_OPEN_DATA_API_URL. It falls back to
// REACT_APP_DEMO_API_URL; with neither set there is no base URL. Then the open data features are
// hidden (openDataAvailable), unless REACT_APP_DRAFT_MOCKS=1 explicitly turns the mocks on.

/** The base URL without a trailing slash, or '' when there is none. Read on each call. */
export function openDataBaseUrl(): string {
  const raw = process.env.REACT_APP_OPEN_DATA_API_URL || process.env.REACT_APP_DEMO_API_URL || '';
  return raw.replace(/\/+$/, '');
}

/** Absolute URL of an open data route (path starts with "/"), or null when there is no base URL. */
export function openDataUrl(path: string): string | null {
  const base = openDataBaseUrl();
  return base ? `${base}/api/demo/open-data${path}` : null;
}

/**
 * Can the open data features (Population baseline, card examples) be shown? Yes with a base URL, or
 * when draft mocks are explicitly on. Otherwise they are hidden: no fetch, no error text.
 * Reads the flag itself so this module stays free of service imports.
 */
export function openDataAvailable(): boolean {
  return openDataBaseUrl() !== '' || process.env.REACT_APP_DRAFT_MOCKS === '1';
}
